<script setup lang="ts">

import { useAppConfiguration } from '@domain/AppConfiguration';
import HowItWorksItem from './HowItWorksItem.vue';

const app = useAppConfiguration();

</script>

<template>

    <div class="flex flex-col gap-0.5 tracking-wider">

        <h1 class="px-4 pt-8 lg:pt-4 pb-3 text-xl 3xl:text-2xl text-center -mb-2 -mt-4">
            How it works
        </h1>
    
        <HowItWorksItem :number="1">
            <template #title>
                Link your Credit or Debit cards
            </template>
            <template #content>
                <p>
                    Securely link your Visa, Mastercard or eftpos cards to get cashback, everytime you shop with our cashback partners.
                </p>
                <p class="mt-2">
                    It takes less than 1 minute and all you need is your card number and expiry.
                </p>
            </template>
        </HowItWorksItem>
        
        <HowItWorksItem :number="2">
            <template #title>
                Start shopping online or instore
            </template>
            <template #content>
                <p>
                    It’s that easy, just shop with one of our Marketplace partners using
                    one of your linked cards, either online through the App, in a browser or instore.
                </p>
            </template>
        </HowItWorksItem>

        <HowItWorksItem :number="3">
            <template #title>
                Earn cashback rewards
            </template>
            <template #content>
                <p>
                    When you make an eligible purchase, you will earn rewards in the form of cashback.
                </p>
                <p class="mt-2">
                    When we are notified of your purchase we will list any cashbacks as Pending in your app. 
                    Once we have verified your purchase hasn’t been returned or changed, cashback will be added to your balance. 
                </p>
                <p class="mt-2">
                    This can take anywhere from 7-90 days to be approved but don’t worry most purchases will 
                    be processed in no time.                    
                </p>
            </template>
        </HowItWorksItem>

        <HowItWorksItem v-if="app.isGeneric"
                        :number="4">
            <template #title>
                Withdraw your cashback!
            </template>
            <template #content>
                <p>
                    Once you reach the minimal balance of $30, you can transfer all or some of your 
                    cashback in to your linked bank account, or keep it saved for your next big car expense.
                </p>
            </template>
        </HowItWorksItem>
    
        <HowItWorksItem v-else
                        :number="4">
            <template #title>
                Take your rewards or save them for your car expenses
            </template>
            <template #content>
                <p>
                    Once you reach the minimal balance of $30, you can use all or some of your 
                    cashback to pay for your car expenses like servicing, tyres, and more.
                </p>
            </template>
        </HowItWorksItem>

    </div>

</template>